import { createInput } from '@formkit/vue';

import InputMention from './mention/InputMention.vue';
import MenuSelect from './menuselect/MenuSelect.vue';
import DropdownSelectorInput from './dropdownSelector/DropdownSelectorInput.vue';

const mention = createInput(InputMention, { props: ['tributeOptions', 'id', 'dataTestId'] });
const menuselect = createInput(MenuSelect, { props: ['preLabel', 'options', 'placeholder'] });
const dropdownSelector = createInput(DropdownSelectorInput, { props: ['testIdPrefix'] });

export const formkitCustoms = {
  mention,
  menuselect,
  dropdownSelector,
};

export * from './chips'; // @deprecated
